/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notification_Session_Success_TitleInputs */

const en_notification_session_success_title = /** @type {(inputs: Notification_Session_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Great Job!`)
};

const ar_notification_session_success_title = /** @type {(inputs: Notification_Session_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أحسنت!`)
};

const de_notification_session_success_title = /** @type {(inputs: Notification_Session_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Großartige Arbeit!`)
};

const es_notification_session_success_title = /** @type {(inputs: Notification_Session_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Buen trabajo!`)
};

const fr_notification_session_success_title = /** @type {(inputs: Notification_Session_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excellent travail !`)
};

const it_notification_session_success_title = /** @type {(inputs: Notification_Session_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ottimo Lavoro!`)
};

const ja_notification_session_success_title = /** @type {(inputs: Notification_Session_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`おつかれさま！`)
};

const ko_notification_session_success_title = /** @type {(inputs: Notification_Session_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`훌륭해요!`)
};

const pt_br_notification_session_success_title = /** @type {(inputs: Notification_Session_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bom trabalho!`)
};

const ru_notification_session_success_title = /** @type {(inputs: Notification_Session_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отлично!`)
};

const th_notification_session_success_title = /** @type {(inputs: Notification_Session_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยอดเยี่ยมมาก!`)
};

const tr_notification_session_success_title = /** @type {(inputs: Notification_Session_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harika iş!`)
};

const zh_cn_notification_session_success_title = /** @type {(inputs: Notification_Session_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`做得好！`)
};

const zh_tw_notification_session_success_title = /** @type {(inputs: Notification_Session_Success_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`做得好！`)
};

/**
* | output |
* | --- |
* | "Great Job!" |
*
* @param {Notification_Session_Success_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const notification_session_success_title = /** @type {((inputs?: Notification_Session_Success_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notification_Session_Success_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notification_session_success_title(inputs)
	if (locale === "ar") return ar_notification_session_success_title(inputs)
	if (locale === "de") return de_notification_session_success_title(inputs)
	if (locale === "es") return es_notification_session_success_title(inputs)
	if (locale === "fr") return fr_notification_session_success_title(inputs)
	if (locale === "it") return it_notification_session_success_title(inputs)
	if (locale === "ja") return ja_notification_session_success_title(inputs)
	if (locale === "ko") return ko_notification_session_success_title(inputs)
	if (locale === "pt_br") return pt_br_notification_session_success_title(inputs)
	if (locale === "ru") return ru_notification_session_success_title(inputs)
	if (locale === "th") return th_notification_session_success_title(inputs)
	if (locale === "tr") return tr_notification_session_success_title(inputs)
	if (locale === "zh_cn") return zh_cn_notification_session_success_title(inputs)
	return zh_tw_notification_session_success_title(inputs)
});